import { useNavigate } from 'react-router-dom';

import sbhrpContent from '../../data/sbhrpContent';
import useTranslation from '../../utils/useTranslation';
import Reveal from '../Reveal';

export default function SbhrpSection() {
  const { t, lang } = useTranslation();
  const navigate = useNavigate();
  const content = sbhrpContent[lang] || sbhrpContent.ar;

  return (
    <section className="section sbhrp-teaser" id="sbhrp">
      <div className="container">
        <div
          className="sbhrp-teaser-panel"
          style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/pro_bg.png)` }}
        >
          <div className="sbhrp-teaser-grid">
            <Reveal as="div" className="sbhrp-teaser-text">
            <h2 className="sbhrp-teaser-title">{content.title}</h2>
            <p className="sbhrp-teaser-body">{content.homeExcerpt}</p>
            <button
              type="button"
              className="featured-project-cta"
              onClick={() => navigate('/sbhrp')}
            >
              <span>{t('read_more')}</span>
              <svg
                className="featured-project-cta-arrow"
                viewBox="0 0 24 24"
                width="16"
                height="16"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <line x1="5" y1="12" x2="19" y2="12" />
                <polyline points="12 5 19 12 12 19" />
              </svg>
            </button>
            </Reveal>

            <Reveal as="div" className="sbhrp-teaser-media" delay={120}>
              <img src={content.homeImage} alt={content.homeImageAlt} loading="lazy" />
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
